import { FC, useEffect } from 'react'
import { Text, Image, Icon } from '@/client/components'
import * as S from './styles'
import { PostTag } from '../PostTag'
import { useGetMedia, useRouterPush } from '@/client/hooks'

export const BlogCard: FC<any> = ({ item }) => {
  const { locale } = useRouterPush()
  const { data } = useGetMedia(item.featured_media || undefined)
  const getDate = (articleDate?: string) => {
    if (!articleDate) {
      return new Date().toISOString().split('T')[0]
    }

    const parsed = new Date(articleDate)

    if (isNaN(parsed.getTime())) {
      return new Date().toISOString().split('T')[0]
    }

    return parsed.toISOString().split('T')[0]
  }

  const getHrefLink = (linkURL) => {
    if (linkURL) {
      const url = new URL(linkURL)
      const pathOnly = url.pathname.replace(/^\/blog/, '')
      const queryString = locale == 'en' ? `/en/blog${pathOnly}` : `/blog${pathOnly}`
      return queryString
    }
    return '/blog'
  }

  useEffect(() => {}, [data])
  return (
    <>
      <S.BlogCardWrapper href={getHrefLink(item['link'])}>
        <S.BlogPreview>
          {data && <Image src={data['source_url'] || '/img/404.png'} fill style={{ objectFit: 'cover' }} />}
        </S.BlogPreview>
        <S.BlogMeta>
          <Text as='p' className='blog-meta-data-date' size='sm' family='text' weight='bold' style={{ margin: '0' }}>
            {getDate(item['date'])}
          </Text>
        </S.BlogMeta>
        <S.BlogHeader>
          <Text as='h5' size='xlg' weight='bold' style={{ margin: '0' }}>
            {item['name']}
          </Text>
          <S.GoToLink>
            <Icon name='new-page' size='s6' />
          </S.GoToLink>
        </S.BlogHeader>
        <S.BlogDescription>
          <Text as='p' style={{ margin: '0' }}>
            {item['description']}
          </Text>
        </S.BlogDescription>
      </S.BlogCardWrapper>
      <S.BlogHashTags>
        <PostTag tags={item['tags']} />
      </S.BlogHashTags>
    </>
  )
}
